import styled from "styled-components"

export default function OrderItemSection({ children }) {
  return <Section>{children}</Section>
}

const Section = styled.div`
  flex: 1 1 auto;
  width: 100%;
  padding: 0 calc(100vw * (17 / 375));
  margin-bottom: calc(100vw * (25 / 375));
`
